import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { FiX } from 'react-icons/fi';
import axios from 'axios';
import { BASE_URL } from '../constants/config';
import { getTokensFromStore, checkIfTokenExpired } from '../utilities/tokens';
import { refreshTokens } from '../actions/usersActions';
import { useI18n } from '../utilities/i18n';
import '../styles/createMatchModal.css';
import '../styles/stagesManagement.css';

function CreateMultipleStagesModal({ isOpen, onClose, onSuccess, league, season }) {
  const dispatch = useDispatch();
  const { t } = useI18n();
  
  const [stagesAmount, setStagesAmount] = useState('1');
  const [baseNamePrefix, setBaseNamePrefix] = useState('Тур');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const amount = parseInt(stagesAmount);
    if (!amount || amount < 1 || amount > 50) {
      setMessage({ text: t('stMultiAmountError'), type: 'error' });
      return;
    }

    if (!baseNamePrefix.trim()) {
      setMessage({ text: t('stMultiNameError'), type: 'error' });
      return;
    }

    setLoading(true);
    setMessage({ text: '', type: '' });

    try {
      const isTokenExpired = checkIfTokenExpired();
      if (isTokenExpired) {
        await dispatch(refreshTokens());
      }
      const tokens = getTokensFromStore();

      const stageData = {
        name: `${baseNamePrefix.trim()} 1`,
        short_name: null,
        priority: 1,
        group_id: null,
        league_id: parseInt(league.value),
        season_id: parseInt(season.value),
        stages_amount: amount,
        matches: []
      };

      await axios.post(
        BASE_URL.url + `/leagues/${league.value}/addStage`,
        stageData,
        {
          headers: {
            Authorization: "Bearer " + tokens.access_token,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      );

      setMessage({ text: t('stMultiCreated', { count: amount }), type: 'success' });
      setTimeout(() => {
        resetForm();
        if (onSuccess) onSuccess();
        onClose();
      }, 1500);
    } catch (error) {
      console.error('Error creating stages:', error);
      setMessage({ 
        text: error.response?.data?.message || t('stMultiError'), 
        type: 'error' 
      });
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setStagesAmount('1');
    setBaseNamePrefix('Тур');
    setMessage({ text: '', type: '' });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-content create-match-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{t('stMultiTitle')}</h2>
          <button className="modal-close" onClick={onClose} type="button">
            <FiX size={24} />
          </button>
        </div>
      
        <div className="modal-body">
          {message.text && (
            <div className={`message-box ${message.type === 'success' ? 'message-success' : 'message-error'}`}>
              {message.text}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-section-modal">
              <label className="form-label-modal form-label-required">
                {t('stMultiCount')}
              </label>
              <input
                className="input-field-modal"
                type="number"
                value={stagesAmount}
                onChange={(e) => setStagesAmount(e.target.value)}
                min="1"
                max="50"
              />
              <small className="form-hint-modal">
                {t('stMultiHint')}
              </small>
            </div>

            <div className="form-section-modal">
              <label className="form-label-modal form-label-required">
                {t('stMultiBase')}
              </label>
              <input
                className="input-field-modal"
                type="text"
                value={baseNamePrefix}
                onChange={(e) => setBaseNamePrefix(e.target.value)}
                placeholder={t('stMultiBase')}
                maxLength={50}
              />
              <small className="form-hint-modal">
                {t('stMultiBaseHint', { name: baseNamePrefix || '...' })}
              </small>
            </div>

            <div className="button-group-modal">
              <button
                type="submit"
                disabled={loading}
                className="btn-modal btn-primary-modal"
              >
                {loading ? t('stCreating') : t('stMultiCreate', { count: stagesAmount })}
              </button>

              <button
                type="button"
                onClick={onClose}
                disabled={loading}
                className="btn-modal btn-secondary-modal"
              >
                {t('cancel')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateMultipleStagesModal;
